import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from 'services/api/api';

import { mapErrorToToastProps } from '../../../../../../utils/forms/mapErrorToToastProps';
import { familyMessages } from '../variables/familyMessages';

export const createSubFamily = async body => {
	const response = await api.post('/subfamily', body);
	return response.data;
};
export const useCreateSubFamily = (
	form?,
	setForm?,
	inputName?: string,
	formProps?,
	setId?,
	setAutocompleteData?
) => {
	const queryClient = useQueryClient();
	const toast = useToast();
	return useMutation(createSubFamily, {
		onSuccess: success => {
			queryClient.invalidateQueries(['family-list']);
			queryClient.invalidateQueries(['family-list-with-products']);
			toast({
				title: familyMessages.MSG_SUBFAMILY_CREATED_SUCCESS,
				description: familyMessages.MSG_SUBFAMILY_CREATED_SUCCESS,
				position: 'bottom-left',
				status: 'success',
				duration: 8000,
				isClosable: true,
			});

			queryClient.invalidateQueries(['subfamily-list']);
			if (form && setForm) {
				setForm({
					...form,
					subfamilia: success.id,
				});
			}

			if (inputName && formProps) {
				const { setValue } = formProps;

				setValue(inputName, String(success.id));

				if (setId) {
					setId(success.id);
				}

				if (setAutocompleteData)
					setAutocompleteData(prev => ({
						...prev,
						sub_family: success,
					}));
			}
		},
		onError: (error: any, variables, context) => {
			const toastErrors: Array<any> = mapErrorToToastProps(
				error,
				familyMessages.MSG_SUBFAMILY_CREATE_ERROR
			);
			toastErrors?.forEach(element => toast(element));
		},
	});
};
